module.exports = __webpack_public_path__ + "img/personage2.52b72433.png";